/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "f64c398c70ba8c047f937111ef23aed0fa87bbae";
